import { Component, OnChanges, Input, ViewChild, NgZone, Output, EventEmitter, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { Department } from "../Models/Department"
import { Ward } from "../Models/Ward"
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { CatalogMasterService } from '../../../../src/app/services/catalog-master.service';
import { ProfessionalCategory } from 'src/app/models/professional-category';
import { ProfessionalSubCategoryDTO } from '../../../../src/app/models/professional-sub-category-dto';
import { finalize, map, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DepartmentType } from '../Models/DepartmentType';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'lib-ph-bhp-filter',
  templateUrl: './ph-bhp-filter.component.html',
  styleUrls: ['./ph-bhp-filter.component.css'],
})
export class PhBhpFilterComponent implements OnInit, OnDestroy {
  singleCard = false;
  @Output() filterRemoved = new EventEmitter<number>();
  @Output() showSubCategories = new EventEmitter<boolean>();
  @Output() filterSaved = new EventEmitter<number>();
  private _filterIndex: number;
  @Input()
  set filterIndex(val: number) {
    this._filterIndex = val;
  }
  get filterIndex() {
    return this._filterIndex;
  }
  @Input() userData;
  @Input() filtersForComp;
  @Input() isDesktop = true;
  @Input() hideProfessionalSubcategory = false;
  @Input() unlockMaxDate = false;
  @Input() evaluationLoaded: boolean;
  @Input() userHasFilter: boolean;
  @Input() isMultiselectReport: boolean = true;
  @Input() showProAndSubPro = true;
  @ViewChild('chipsDiv', { static: true }) chipsDiv: ElementRef;
  @ViewChild('chipsDivOuter', { static: true }) chipsDivOuter: ElementRef;

  filterFlag: boolean = true;
  visible: boolean = true;
  compareInstitutionFn = this.compareFnFactory('institutionID');
  compareCountryFn = this.compareFnFactory('countryID');
  compareDepartmentFn = this.compareFnFactory('departmentID');
  compareDepartmentTypeFn = this.compareFnFactory('departmentTypeID');
  compareWardFn = this.compareFnFactory('wardID');
  compareCategoryFn = this.compareFnFactory('categoryID');
  compareSubCategoryFn = this.compareFnFactory('subCategoryID');
  compareEntryFn = this.compareFnFactory('entryId');
  compareFnFactory(prop: string) {
    return (a: any, b: any) => {
      if (a && b) {
        return a[prop] === b[prop];
      }
    };
  }

  roleId;
  range1 = {
    start: new Date(),
    end: new Date()
  }
  range = {
    start: new Date().toUTCString(),
    end: new Date().toUTCString()
  }
  maxDate = new Date()
  minDate: Date = void 0;
  countryList: Array<any>;
  institutionsList: Array<any> = [];
  institutionsListLoaded: Array<any> = [];
  professionalCategoryList: ProfessionalCategory[];
  allSubCategoryList: ProfessionalSubCategoryDTO[];
  subCategoryList: ProfessionalSubCategoryDTO[];
  subCategoryListLoaded: ProfessionalSubCategoryDTO[];
  departmentList: Department[];
  departmentTypeList: DepartmentType[];
  wardList: Ward[];
  wardListLoaded: Ward[];
  country: any;
  institution: any;
  ward: any;
  filterName: any;
  department: any;
  departmentType: any;
  category: any;
  subCategory: any;
  showProfessionalSubcategory: boolean = false;
  showProfessionalSubcategoryChecked: boolean = false;
  allInstitutionsProfessionalSubcategoryEnabled: boolean = true;
  setCountry: any = 0;
  setInstitution: any = 0;
  setWard: any = 0;
  setFilterName: any = 0;
  setDepartment: any = 0;
  setDepartmentType: any = 0;
  setCategory: any = 0;
  setSubCategory: any = 0;
  dateRange: Date[];
  today: Date;
  singleInstitution = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  showTrashButton: boolean = false;
  defaultStartDate: Date;
  defaultEndDate: Date;
  setDate: boolean = false;
  showMultiselect: boolean = false;
  multiselectOption: string = 'CONFIGURE.DEPARTMENT';
  entrySelected: any = {};
  entryAllSelectedText: string = 'EVALUATION.All.DEPARTMENTS';
  entryNothingSelected: boolean = false;
  entriesSelected: any[] = [];
  entriesSelectedSubject = new Subject<boolean>();
  entriesSelectedChips: any[] = [];
  entriesList: any[] = [
    { entryId: 'dept', name: 'CONFIGURE.DEPARTMENT' },
    { entryId: 'deptType', name: 'CONFIGURE.DEPARTMENT_TYPE' },
    { entryId: 'ward', name: 'CONFIGURE.WARD' },
    { entryId: 'cat', name: 'CONFIGURE.PROFESSIONAL_CATEGORY' },
    { entryId: 'subcat', name: 'CONFIGURE.PROFESSIONAL_SUB_CATEGORY' }
  ];
  showEntries: any[] = this.entriesList;
  exportMultiselect: any = {};
  currentStartDate: Date;
  currentEndDate: Date;
  isNewFilter: boolean = false;
  filterButtonPosition: boolean = false;
  viewMore: boolean = false;
  lessMoreIsVisible: boolean = false;
  selectedEntriesCount: number = 0;

  constructor(
    private layoutService: PHBHPLayoutPackageService,
    public translate: TranslateService,
    public filtersService: FiltersService
  ) {
    var date = new Date();
    this.today = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    var start = this.today.getTime() - (10 * 24 * 60 * 60 * 1000);
    var end = this.today;
    this.dateRange = [new Date(start), new Date(end)];
    this.defaultStartDate = new Date(start);
    this.defaultEndDate = new Date(end);
    this.setDate = false;

    this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') }
    this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    this.category = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
  }

  ngOnInit() {
    this.roleId = this.userData.roleName.roleId;
    // Only set a default filter name when there is no previously set name
    if (!this.setFilterName || (typeof this.setFilterName === 'string' && this.setFilterName.trim() === '')) {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.setFilterName = this.filterName;
    } else {
      this.filterName = this.setFilterName;
    }
    this.selectDate();
    this.loadInstitutions();
    this.filtersService.institutionSubject.subscribe(loaded => {
      this.loadInstitutions();
    })

    this.departmentList = this.filtersService.departmentList;
    if (this.departmentList) {
      this.departmentList = this.departmentList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentName)).localeCompare(this.layoutService.translateText(b.departmentName));
      });
    }

    this.filtersService.departmentListSubject.subscribe(loaded => {
      this.departmentList = this.filtersService.departmentList;
      this.departmentList = this.departmentList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentName)).localeCompare(this.layoutService.translateText(b.departmentName));
      });
    })

    this.departmentTypeList = this.filtersService.departmentTypeList;
    if (this.departmentTypeList) {
      this.departmentTypeList = this.departmentTypeList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentTypeName)).localeCompare(this.layoutService.translateText(b.departmentTypeName));
      });
    }

    this.filtersService.departmentTypeListSubject.subscribe(loaded => {
      this.departmentTypeList = this.filtersService.departmentTypeList;
      this.departmentTypeList = this.departmentTypeList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentTypeName)).localeCompare(this.layoutService.translateText(b.departmentTypeName));
      });
    });

    this.countryList = this.filtersService.countryList;
    this.filtersService.countryListSubject.subscribe(loaded => {
      this.countryList = this.filtersService.countryList;
    })

    this.professionalCategoryList = this.filtersService.professionalCategoryList;
    if (this.professionalCategoryList) {
      this.professionalCategoryList = this.professionalCategoryList.sort((a, b) => {
        return (this.layoutService.translateText(a.categoryName)).localeCompare(this.layoutService.translateText(b.categoryName));
      });
    }

    this.filtersService.professionalCategorySubject.subscribe(loaded => {
      this.professionalCategoryList = this.filtersService.professionalCategoryList;
      this.professionalCategoryList = this.professionalCategoryList.sort((a, b) => {
        return (this.layoutService.translateText(a.categoryName)).localeCompare(this.layoutService.translateText(b.categoryName));
      });
    })

    this.loadSubCategories();
    this.filtersService.subCategoryListSubject.subscribe(loaded => {
      this.loadSubCategories();
    })

    this.wardList = this.filtersService.wardList;
    this.filtersService.wardListSubject.subscribe(loaded => {
      this.wardList = this.filtersService.wardList;
    })

  }

  ngOnDestroy() {
    this.entriesSelectedChips = [];
  }

  loadInstitutions() {
    this.institutionsList = this.filtersService.institutionsList || [];
    this.institutionsList = this.institutionsList.sort((a, b) => {
      return (this.layoutService.translateText(a.institutionName)).localeCompare(this.layoutService.translateText(b.institutionName));
    });
    this.checkAllInstitutionsHasProfessionalSubcategoryEnabled();
    if (!this.showProAndSubPro) {
      this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
    } else {
      if (!this.allInstitutionsProfessionalSubcategoryEnabled) {
        this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat');
      } else {
        this.showEntries = this.entriesList;
      }
    }
  }

  loadSubCategories() {
    this.allSubCategoryList = this.filtersService.allSubCategoryList;
    if (this.userData.roleName.roleId === 2) {

    } else if (this.userData.roleName.roleId === 3) {


    }

  }

  showFilter(isNewFilter = false) {
    this.filterButtonPosition = false;
    this.singleCard = !this.singleCard;
    this.currentStartDate = this.dateRange[0];
    this.currentEndDate = this.dateRange[1];
    this.isNewFilter = isNewFilter;
    // Only set a default name when this is a new filter and no name has been provided
    if (isNewFilter && (!this.setFilterName || (typeof this.setFilterName === 'string' && this.setFilterName.trim() === ''))) {
      const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.filterName = translatedFilterName;
      this.setFilterName = translatedFilterName;
    } else if (!isNewFilter && (!this.filterName || (typeof this.filterName === 'string' && this.filterName.trim() === ''))) {
      // If opening existing filter but current filterName is empty, preserve setFilterName if available
      if (this.setFilterName && typeof this.setFilterName === 'string' && this.setFilterName.trim() !== '') {
        this.filterName = this.setFilterName;
      } else {
        const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
        this.filterName = translatedFilterName;
        this.setFilterName = translatedFilterName;
      }
    }
    setTimeout(() => {
      this.filterButtonPosition = true;
    }, 320);
  }

  public setInfoFromFilter(filter) {
    this.dateRange = { ...filter.dateRange };
    this.range = { ...filter.range };
    this.range1 = { ...filter.range1 };
    this.defaultStartDate = filter.defaultStartDate;
    this.defaultEndDate = filter.defaultEndDate;
    this.setDate = filter.setDate;
    this.country = filter.country;
    this.setCountry = filter.setCountry;
    this.institution = filter.institution;
    this.setInstitution = filter.setInstitution;
    this.ward = filter.ward;
    this.setWard = filter.setWard;

    //Always NAME = 'Filter' + last index +1
    const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    this.filterName = translatedFilterName;
    this.setFilterName = translatedFilterName;
    
    this.wardList = filter.wardList;
    this.wardListLoaded = filter.wardListLoaded;
    this.department = filter.department;
    this.setDepartment = filter.setDepartment;
    this.departmentType = filter.departmentType;
    this.setDepartmentType = filter.setDepartmentType;
    this.category = filter.category;
    this.setCategory = filter.setCategory;
    this.showMultiselect = filter.showMultiselect;
    this.multiselectOption = filter.multiselectOption;
    this.entrySelected = filter.entrySelected;
    this.entryAllSelectedText = filter.entryAllSelectedText;
    this.entryNothingSelected = filter.entryNothingSelected;
    this.entriesSelected = filter.entriesSelected;
    this.entriesSelectedChips = filter.entriesSelectedChips;
    this.entriesList = filter.entriesList;
    this.showEntries = filter.showEntries;
    this.exportMultiselect = filter.exportMultiselect;

    if(filter.showProfessionalSubcategory){
      this.subCategory = filter.subCategory;
      this.setSubCategory = filter.setSubCategory;
      this.showProfessionalSubcategory = filter.showProfessionalSubcategory;
      this.setProfessionalSubCategory(filter.setSubCategory.subCategoryID, true);

    }

    this.showFilter(true);
  }

  public resetFilter(isManualUpdate: boolean = true) {
    var date = new Date();
    this.today = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    var start = this.today.getTime() - (10 * 24 * 60 * 60 * 1000);
    var end = this.today;
    this.dateRange = [new Date(start), new Date(end)];
    this.selectDate();

    this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    this.setFilterName = this.filterName;
    
    if (this.setCountry && this.roleId == 1) this.countryRemoved();
    if (this.setInstitution) this.institutionRemoved();
    if (this.setDepartment) this.departmentRemoved();
    if (this.setDepartmentType) this.departmentTypeRemoved();
    if (this.setWard) this.wardRemoved();
    if (this.setCategory) this.categoryRemoved();
    if (this.setSubCategory) this.subCategoryRemoved();
    if (this.showMultiselect) {
      this.multiSelectRemoved();
    }

    this.setFilter(isManualUpdate);

  }

  countryRemoved() {
    this.setCountry = 0;
    this.setInstitution = 0;
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setWard = 0;
    this.onWardChange(0);
    this.onInstitutionChange(0);
    this.setCategory = 0;
    this.onCategoryChange(0);
    this.setSubCategory = 0;
    this.onSubCategoryChange(0);
    this.setFilter();
  }

  institutionRemoved() {
    if (this.singleInstitution) {
      return;
    }
    this.setInstitution = 0;
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setWard = 0;
    this.onWardChange(0);
    this.onInstitutionChange(0);
    this.setCategory = 0;
    this.onCategoryChange(0);
    this.setSubCategory = 0;
    this.onSubCategoryChange(0);
    this.setFilter();
  }

  departmentRemoved() {
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setFilter();
  }

  departmentTypeRemoved() {
    this.setDepartmentType = 0;
    this.onDepartmentTypeChange(0);
    this.setFilter();
  }

  wardRemoved() {
    this.setWard = 0;
    this.onWardChange(0);
    this.setFilter();
  }

  categoryRemoved() {
    this.setCategory = 0;
    this.onCategoryChange(0);
    this.setFilter();
  }

  subCategoryRemoved() {
    this.setSubCategory = 0;
    this.onSubCategoryChange(0);
    this.setFilter();
  }

  selectDate() {
    var startDate = new Date(this.dateRange[0].getFullYear(), this.dateRange[0].getMonth(), this.dateRange[0].getDate(), 0, 0, 0);
    if (this.dateRange[1] == null) {
      return;
    }

    var endDate = new Date(this.dateRange[1].getFullYear(), this.dateRange[1].getMonth(), this.dateRange[1].getDate(), 23, 59, 59);
    if (startDate > endDate) {
      // this.layoutService.showError(this.layoutService.translateText('WEBKESS_INTEGRATION.EXPORT.END_DATE'));
    } else {
      this.range1.start = startDate;
      this.range1.end = endDate;
      this.range.start = this.layoutService.convertLocalDateToUTCString(this.range1.start);
      this.range.end = this.layoutService.convertLocalDateToUTCString(this.range1.end);
    }
  }

  cancelFilter() {
    if (this.isNewFilter) {
      this.removeNewFilter();
      return;
    }

    if (this.roleId == 1) {
      if (this.setCountry != 0) {
        this.country = this.filtersService.countryList.find((res1) => res1.countryID == this.setCountry.countryID);
      } else {
        this.singleCard = false;
        return;
      }

    }

    if (this.setDepartment && this.setDepartment != 0) {
      this.department = this.filtersService.departmentList.find((res1) => res1.departmentID == this.setDepartment.departmentID);
    } else {
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }

    if (this.setFilterName && this.setFilterName != "") {
      this.filterName = this.setFilterName;
    } else {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    }

    if (this.setDepartmentType && this.setDepartmentType != 0) {
      this.departmentType = this.filtersService.departmentTypeList.find((res1) => res1.departmentTypeID == this.setDepartmentType.departmentTypeID);
    } else {
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }

    if(this.setCategory && this.setCategory != 0) {
      this.setCategory = this.filtersService.professionalCategoryList.find((cat) => cat.categoryID == this.setCategory.categoryID);
    }else{
      this.setCategory = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    }

    if(this.setSubCategory && this.setSubCategory != 0) {
      this.setSubCategory = this.allSubCategoryList.find((subCat) => subCat.subCategoryID == this.setSubCategory.subCategoryID);
    }else{
      this.setSubCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    }

    this.singleCard = false;
    this.dateRange[0] = this.currentStartDate;
    this.dateRange[1] = this.currentEndDate;
  }

  setFilter(isManualUpdate = false) {

    if (!isManualUpdate && this.showMultiselect && this.entriesSelected.filter(entry => entry.selected).length == 0) {
      this.layoutService.showError(this.layoutService.translateText('EVALUATION.FILTERS.SELECT_AT_LEAST_ONE'));
      this.filterButtonPosition = true;
      this.singleCard = true;
      setTimeout(() => {
        this.filterButtonPosition = true;
      },);
      return;
    }

    var startDate = new Date(this.dateRange[0].getFullYear(), this.dateRange[0].getMonth(), this.dateRange[0].getDate(), 0, 0, 0);
    if (this.dateRange[1] == null) {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.FILTERS.SELECT_END_DATE'));
      return;
    }

    var endDate = new Date(this.dateRange[1].getFullYear(), this.dateRange[1].getMonth(), this.dateRange[1].getDate(), 23, 59, 59);
    this.setDate = !(
      (this.dateRange[0].getFullYear() == this.defaultStartDate.getFullYear() && this.dateRange[0].getMonth() == this.defaultStartDate.getMonth() && this.dateRange[0].getDate() == this.defaultStartDate.getDate()) &&
      (this.dateRange[1].getFullYear() == this.defaultEndDate.getFullYear() && this.dateRange[1].getMonth() == this.defaultEndDate.getMonth() && this.dateRange[1].getDate() == this.defaultEndDate.getDate())
    );
    if (startDate > endDate) {
      this.layoutService.showError(this.layoutService.translateText('WEBKESS_INTEGRATION.EXPORT.END_DATE'));
      return;
    }

    if (this.country && this.country.countryID && this.country.countryID !== 0) {
      this.setCountry = this.country;
    } else {
      this.setCountry = 0;
      this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
    }

    if (this.institution && this.institution.institutionID && this.institution.institutionID !== 0) {
      this.setInstitution = this.institution;
      // this.checkSingleInstitutionProfessionalSubcategoryEnabled();
    } else {
      this.setInstitution = 0;
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    }

    if (this.ward && this.ward.wardID && this.ward.wardID !== 0) {
      this.setWard = this.ward;
    } else {
      this.setWard = 0;
      this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    }

    if (this.filterName && this.filterName.trim() !== "") {
      this.filterName = this.filterName.trim();
      this.setFilterName = this.filterName;
    } else {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.setFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    }

    if (this.department && this.department.departmentID && this.department.departmentID !== 0) {
      this.setDepartment = this.department;
    } else {
      this.setDepartment = 0;
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }

    if (this.departmentType && this.departmentType.departmentTypeID && this.departmentType.departmentTypeID !== 0) {
      this.setDepartmentType = this.departmentType;
    } else {
      this.setDepartmentType = 0;
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }

    if (this.category && this.category.categoryID && this.category.categoryID !== 0) {
      this.setCategory = this.category;
    } else {
      this.setCategory = 0;
      this.category = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    }

    if (this.subCategory && this.subCategory.subCategoryID && this.subCategory.subCategoryID !== 0) {
      this.setSubCategory = this.subCategory;
    } else {
      this.setSubCategory = 0;
      this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    }

    if (this.showMultiselect) {
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected && e.entryId !== '-1');
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
    if (!isManualUpdate) {
      this.singleCard = false;
      this.filterSaved.emit();
    }
  }

  onCountryChange(country, loadForSA = false) {
    this.cleanInstitution();
    this.cleanWard();
    this.cleanDepartment();
    this.cleanCategory();
    this.cleanSubCategory();
    if (country == 0) {
      this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
      return of(null);
    }
    else {
      this.country = country;
    }
    this.layoutService.startLoadingFilter();
    if (loadForSA) {
      return this.filtersService.onCountryChange(this.country.countryID);
    }
    this.filtersService.onCountryChange(this.country.countryID).subscribe(institutions => {
      this.filtersService.filterInstitutions(institutions[0]);
      this.filtersService.institutionSubject.next(true);
      this.filtersService.getWardsByInstitutions();
      this.layoutService.stopLoadingFilter();

    });

  }

  onInstitutionChange(value, hideLoader = true) {
    // this.layoutService.showLoader = true;
    this.cleanWard();
    this.cleanDepartment();
    this.cleanDepartmentType();
    this.cleanCategory();
    this.cleanSubCategory();
    this.category = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    if (value && value.institutionID) {
      this.institution = value;
      this.setInstitution = value;
      this.showProfessionalSubcategory = this.institution.enableProfessionalSubCategory;
      this.loadWardsByInstitution(value.institutionID);
      if (!this.showProAndSubPro) {
        this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
      } else {
        if (!this.showProfessionalSubcategory) {
          this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat');
          this.onEntryChange(this.entriesList[0]);
        } else {
          this.showEntries = this.entriesList;
        }
      }

      this.checkAllInstitutionsHasProfessionalSubcategoryEnabled();
    } else {
      delete this.setInstitution;
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
      this.showProfessionalSubcategory = false;
      this.checkAllInstitutionsHasProfessionalSubcategoryEnabled();
      if (!this.showProAndSubPro) {
        this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
      } else {
        if (!this.allInstitutionsProfessionalSubcategoryEnabled) {
          this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat');
          this.onEntryChange(this.entriesList[0]);
        } else {
          this.showEntries = this.entriesList;
        }
      }
      this.showSubCategories.emit(this.showProfessionalSubcategory || this.allInstitutionsProfessionalSubcategoryEnabled);
    }
    this.loadMultiFilterWards();
    if (this.showMultiselect) {
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected);
    } else {
      this.entriesSelectedChips = [];
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
    this.layoutService.stopLoadingFilter();
  }


  onWardChange(value) {
    if (value == 0) {
      this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    }
    else {
      this.ward = value;
    }
  }

  onCategoryChange(value) {
    this.layoutService.showLoader = true;
    this.cleanSubCategory();
    if (value == 0) {
      this.category = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    } else {
      this.category = value;
      if (this.showProfessionalSubcategory || this.allInstitutionsProfessionalSubcategoryEnabled) {
        this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
        this.subCategoryListLoaded = this.allSubCategoryList.filter(subCat => subCat.categoryID == value.categoryID);
        this.subCategoryListLoaded = this.subCategoryListLoaded.sort((a, b) => {
          return (this.layoutService.translateText(a.subCategoryName)).localeCompare(this.layoutService.translateText(b.subCategoryName));
        });
      }
    }
    if (this.showMultiselect && (this.showProfessionalSubcategory || this.allInstitutionsProfessionalSubcategoryEnabled)) {
      this.loadMultiFilterSubcategories();
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected);
    }
    this.setCategory = this.category;
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
    this.layoutService.showLoader = false;
  }

  onSubCategoryChange(value) {
    if (value == 0) {
      this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    }
    else {
      this.subCategory = value;
    }
  }

  onDepartmentChange(value) {
    if (value == 0) {
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }
    else {
      this.department = value;
    }
  }

  onDepartmentTypeChange(value) {
    if (value == 0) {
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }
    else {
      this.departmentType = value;
    }
  }

  onFilterNameChange(value: string) {
    if (value && value.trim() !== "") {
      this.filterName = value;
    } else {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER');
    }
  }

  cleanInstitution() {
    this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
  }

  cleanWard() {
    this.wardListLoaded = [];
    this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
  }

  cleanDepartment() {
    this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
  }

  cleanDepartmentType() {
    this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
  }

  cleanCategory() {
    this.category = { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
  }

  cleanSubCategory() {
    this.subCategory = { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    this.subCategoryListLoaded = [];
  }

  loadWardsByInstitution(id) {
    if (this.wardList) {
      this.wardListLoaded = this.wardList.filter(ward => ward.institutionID == id);
      this.wardListLoaded = this.wardListLoaded.sort((a, b) => {
        return (this.layoutService.translateText(a.wardName)).localeCompare(this.layoutService.translateText(b.wardName));
      });
    } else {
      this.filtersService.wardListSubject.subscribe(loaded => {
        this.wardListLoaded = this.wardList.filter(ward => ward.institutionID == id);
        this.wardListLoaded = this.wardListLoaded.sort((a, b) => {
          return (this.layoutService.translateText(a.wardName)).localeCompare(this.layoutService.translateText(b.wardName));
        });
      });
    }
  }

  assignData(data) {
    if (this.setInstitution != 0) {
      data.instutionIDs = this.setInstitution.institutionID;

      //this.checkSingleInstitutionProfessionalSubcategoryEnabled();
    }
    if (this.setFilterName)
      data.filterName = this.setFilterName;
    if (this.setWard != 0)
      data.wardID = this.setWard.wardID
    if (this.setDepartment != 0)
      data.departmentID = this.setDepartment.departmentID
    if (this.setDepartmentType != 0)
      data.departmentTypeID = this.setDepartmentType.departmentTypeID
    if (this.setCategory != 0)
      data.professionalCategoryID = this.setCategory.categoryID
    if (this.setSubCategory != 0)
      data.subprofessionalCategoryID = this.setSubCategory.subCategoryID
    if (this.showMultiselect) {
      data.multiselect = true;
      data.multiSelectFilter = this.entrySelected.entryId;
      data.multiSelectName = this.entrySelected.name;
      data.multiSelectValues = this.entriesSelected.filter(entry => entry.selected).map(entry => { return { id: entry.entryId, name: entry.name } });
      this.exportMultiselect = {
        multiselect: data.multiselect,
        multiSelectFilter: data.multiSelectFilter,
        multiSelectValues: data.multiSelectValues
      }
    }
    return data
  }


  setSAFilter(filter, isManualUpdate = false) {
    let countryId = filter.CountryID || filter.countryID; // workaround for differences between contexts...
    let country = this.filtersService.countryList.find((list) => list.countryID == countryId);
    this.onCountryChange(country || 0, true).subscribe((institutions) => {
      if (institutions) {
        this.filtersService.filterInstitutions(institutions[0]);
        this.filtersService.institutionSubject.next(true);
        this.filtersService.getWardsByInstitutions();
      } else {
        this.filtersService.filterInstitutions([]);
        this.filtersService.institutionSubject.next(true);
        this.filtersService.getWardsByInstitutions();
      }
      this.setInstitutionsByID(filter.instutionIDs, true);
      this.filtersService.wardListSubject.subscribe(loaded => {
        if (this.wardListLoaded && this.wardListLoaded.length > 0 && filter.wardID) {
          this.onWardChange(this.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          this.setWard = this.ward;
        }
      });
      this.setFilterNameFilter(filter.filterName, true);
      this.setDepartmentFilter(filter.departmentID, true);
      this.setDepartmentTypeFilter(filter.departmentTypeID, true);
      let subprofessionalCategoryID = filter.SubprofessionalCategoryID || filter.subprofessionalCategoryID; // workaround for differences between contexts...
      this.setProfessionalCategory(filter.professionalCategoryID, subprofessionalCategoryID, true);
      if (filter.multiselect) {
        let multiSelectFilterValue = filter.multiSelectFilter ? filter.multiSelectFilter : filter.multiselectFilter;
        let multiSelectValuesValue = filter.multiSelectValues ? filter.multiSelectValues : filter.multiselectValues;
        this.setMultiFilter(filter.multiselect, multiSelectFilterValue, multiSelectValuesValue, true);
      }
      this.layoutService.stopLoadingFilter();

    });
  }

  setCountryFilter(countryID, dummy, dummy2, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.countryList) {
      setCountry(isManualUpdate);
    }
    else {
      if (this.roleId == 1) {
        var countryListSubject1 = this.filtersService.countryListSubject.asObservable().subscribe(res => {
          countryListSubject1.unsubscribe();
          setCountry(isManualUpdate);
        })
      }
      else {
        self.setFilter(isManualUpdate);
      }
    }

    function setCountry(isManualUpdate = false) {
      if (self.filtersService.countryList.length > 0 && countryID !== 0) {
        self.country = self.filtersService.countryList.find((list) => list.countryID == countryID);
      } else {
        self.country = { countryName: self.layoutService.translateText('EVALUATION.All.COUNTRIES') };
      }

      self.setFilter(isManualUpdate);
    }
  }

  setFilterNameFilter(filterName: string, isManualUpdate = false) {
    var self = this;
    setFilterName(isManualUpdate);

    function setFilterName(isManualUpdate = false) {
      if (filterName && filterName.trim() !== "") {
        self.filterName = filterName;
      } else {
        // Solo asignar el nombre por defecto cuando se llama explícitamente este método
        self.filterName = self.layoutService.translateText('EVALUATION.FILTER') + ' ' + (self.filterIndex + 1);
      }
      self.setFilter(isManualUpdate);
    }
  }

  setDepartmentFilter(departmentId, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.departmentList) {
      setDepartment(isManualUpdate);
    } else {
      var subscriptionDepartmentList = this.filtersService.departmentListSubject.asObservable().subscribe(res => {
        subscriptionDepartmentList.unsubscribe();
        setDepartment(isManualUpdate);
      });
    }
    function setDepartment(isManualUpdate = false) {
      if (departmentId == "") {
        self.department = { departmentName: self.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
      } else {
        if (self.filtersService.departmentList.length > 0) {
          self.department = self.filtersService.departmentList.find((res) => res.departmentID == departmentId);
          self.setFilter(isManualUpdate);
        }
      }
    }
  }

  setDepartmentTypeFilter(departmentTypeId, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.departmentTypeList) {
      setDepartmentType(isManualUpdate);
    } else {
    }
    function setDepartmentType(isManualUpdate = false) {
      if (departmentTypeId == "") {
        self.departmentType = { departmentTypeName: self.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
      } else {
        if (self.filtersService.departmentTypeList.length > 0) {
          self.departmentType = self.filtersService.departmentTypeList.find((res) => res.departmentTypeID == departmentTypeId);
          self.setFilter(isManualUpdate);
        }
      }
    }
  }

  setProfessionalCategory(categoryId, subcategoryId, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.professionalCategoryList) {
      setCategory(isManualUpdate);
    } else {
      var subscriptionProfessionalCategory = this.filtersService.professionalCategorySubject.asObservable().subscribe(res => {
        subscriptionProfessionalCategory.unsubscribe();
        setCategory(isManualUpdate);
      });
    }

    function setCategory(isManualUpdate = false) {
      if (categoryId == "") {
        self.category = { categoryName: self.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
        if (subcategoryId != '') {
          self.setProfessionalSubCategory(subcategoryId, isManualUpdate)
        }
      } else {
        if (self.filtersService.professionalCategoryList.length > 0) {
          self.category = self.filtersService.professionalCategoryList.find((list) => list.categoryID == categoryId);
          if(!self.allSubCategoryList || self.allSubCategoryList.length == 0){
            setTimeout(() => {
              self.subCategoryListLoaded = self.allSubCategoryList.filter(subCat => subCat.categoryID == categoryId);
              self.subCategoryListLoaded = self.subCategoryListLoaded.sort((a, b) => {
                return (self.layoutService.translateText(a.subCategoryName)).localeCompare(self.layoutService.translateText(b.subCategoryName));
              });
              self.setProfessionalSubCategory(subcategoryId, isManualUpdate)
              self.setFilter(isManualUpdate);
            }, 500);
          }else{
            self.subCategoryListLoaded = self.allSubCategoryList.filter(subCat => subCat.categoryID == categoryId);
            self.subCategoryListLoaded = self.subCategoryListLoaded.sort((a, b) => {
              return (self.layoutService.translateText(a.subCategoryName)).localeCompare(self.layoutService.translateText(b.subCategoryName));
            });
            self.setProfessionalSubCategory(subcategoryId, isManualUpdate)
            self.setFilter(isManualUpdate);
          }
        }
      }
    }
  }

  private getCountryIdByRole() {
    let countryId = this.layoutService.institutionCountryId;
    if (this.roleId == 1 && this.country && this.country.countryID !== 0) {
      countryId = this.country.countryID;
    } else if (this.roleId == 2 && this.userData && this.userData.country !== 0) {
      countryId = this.userData.country;
    }
    return countryId;
  }

  setProfessionalSubCategory(subcategoryId, isManualUpdate = false) {
    //this.setSubCategoriesVisibility();
    if (!this.filtersService.subCategoryList || !this.filtersService.subCategoryList.some(sub => sub.subCategoryID == subcategoryId)) {
      this.subCategory = 0;
      this.setFilter(isManualUpdate);
    } else if (this.filtersService.allSubCategoryList && this.filtersService.allSubCategoryList.length > 0) {
      this.subCategory = this.filtersService.allSubCategoryList.find((list) => list.subCategoryID == subcategoryId);
      this.subCategoryListLoaded = this.allSubCategoryList.filter(subCat => subCat.categoryID == this.subCategory.categoryID);
      this.subCategoryListLoaded = this.subCategoryListLoaded.sort((a, b) => {
        return (this.layoutService.translateText(a.subCategoryName)).localeCompare(this.layoutService.translateText(b.subCategoryName));
      });
      this.setFilter(isManualUpdate);
    }
    this.onSubCategoryChange(this.subCategory);
  }



  setInstitutionsByID(InstitutionId, isManualUpdate = false) {
    var self = this;
    if (InstitutionId) {
      var tempArray = InstitutionId.toString().split(',')
      if (tempArray.length != 1) {
        return false;
      }
      this.allInstitutionsProfessionalSubcategoryEnabled = false;
      if (this.roleId == 1) {
        this.institution = this.filtersService.institutionsList.find((list) => {
          setSubCategoryVisibility(list.enableProfessionalSubCategory);
          return list.institutionID == InstitutionId
        });
        this.setFilter(isManualUpdate);
      } else {
        if (this.filtersService.institutionsList && this.filtersService.institutionsList.length > 0) {
          this.institution = this.filtersService.institutionsList.find((list) => list.institutionID == InstitutionId);
          setSubCategoryVisibility(this.institution?.enableProfessionalSubCategory);

          this.setFilter(isManualUpdate);
        } else {
          this.filtersService.institutionSubject.subscribe(res => {
            this.institution = this.filtersService.institutionsList.find((list) => list.institutionID == InstitutionId);
            setSubCategoryVisibility(this.institution?.enableProfessionalSubCategory);
            this.setFilter(isManualUpdate);
          })
        }
      }

      this.onInstitutionChange(this.institution, false);
    } else {
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
      this.checkAllInstitutionsHasProfessionalSubcategoryEnabled();
    }

    function setSubCategoryVisibility(showSubCategory) {
      self.showProfessionalSubcategory = showSubCategory;
      if (self.showMultiselect) {
        if (!self.showProAndSubPro) {
          self.showEntries = self.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
        } else {
          if (!self.showProfessionalSubcategory) {
            self.showEntries = self.entriesList.filter(entry => entry.entryId !== 'subcat');
            self.onEntryChange(self.entriesList[0]);
          } else {
            self.showEntries = self.entriesList;
          }
        }
      }
    }

  }

  isWardSelected() {
    return this.ward && this.ward.wardID && this.ward.wardID !== 0;
  }

  removeFilter() {
    this.filterRemoved.emit(this.filterIndex);
  }

  setSubCategoriesVisibility() {
    this.filtersService.subCategoryList = this.filtersService.allSubCategoryList?.filter(this.filterVisibility);
  }

  filterVisibility = (subCategory: ProfessionalSubCategoryDTO) => {
    switch (this.roleId) {
      case 1: // SA
        return true;
      case 2: // CA
        if (!subCategory.professionalSubCategoryCountryConfiguration || subCategory.professionalSubCategoryCountryConfiguration.visibilityType === 'all') {
          return true;
        } else {
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.userData.country);
        }
      case 3: // GA
      case 4: // IA
      case 5: // IU
        if (!subCategory.professionalSubCategoryCountryConfiguration) {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA && subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.length > 0) {
          let enability = subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.find(e => e.institutionId == this.layoutService.institutionID);
          return enability ? enability.isEnabledForNewObservations : true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.visibilityType === 'all') {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'institutions') {
          if (this.institution.institutionID) {
            return subCategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility.some(v => v.institutionId == this.institution.institutionID);
          } else {
            return subCategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility.some(v => this.filtersService.institutionsList.some(i => i.institutionID == v.institutionId));
          }
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'country') {
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.userData.country);
        }
        return false;
    }
  }

  closeSidebarEvent(event) {
    this.singleCard = event.val;
    if (this.isNewFilter) {
      this.removeNewFilter();
      return;
    }
  }

  removeNewFilter() {
    if (this.filterIndex != 0) {
      this.removeFilter();
    } else {
      this.singleCard = false;
    }
  }

  setDefaultDate(event: Event) {
    event.stopPropagation();
    this.setDate = false;
    this.dateRange = [this.defaultStartDate, this.defaultEndDate];
    this.range = { start: this.layoutService.convertLocalDateToUTCString(this.defaultStartDate), end: this.layoutService.convertLocalDateToUTCString(this.defaultEndDate) };
    this.setFilter();
  }

  compareDates(a, b) {
    return a.getFullYear() == b.getFullYear() && a.getMonth() == b.getMonth() && a.getDate() == b.getDate();
  }

  getActiveFilters() {
    var start = new Date(this.today.getTime() - (10 * 24 * 60 * 60 * 1000));
    var end = this.today;
    var activeFilters = 0;
    if (this.dateRange[0] == null || this.dateRange[1] == null) {
      activeFilters++;
    } else if (!this.compareDates(this.dateRange[0], start) || !this.compareDates(this.dateRange[1], end)) {
      activeFilters++;
    }

    if (this.roleId == 1 && this.country.countryName != this.layoutService.translateText('EVALUATION.All.COUNTRIES')) {
      activeFilters++;
    }

    if (this.institution.institutionName != this.layoutService.translateText('EVALUATION.All.INSTITUTIONS')) {
      activeFilters++;
    }

    if (this.ward.wardName != this.layoutService.translateText('EVALUATION.All.WARDS')) {
      activeFilters++;
    }

    if (this.department.departmentName != this.layoutService.translateText('EVALUATION.All.DEPARTMENTS')) {
      activeFilters++;
    }

    if (this.layoutService.translateText(this.departmentType.departmentTypeName) != this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES')) {
      activeFilters++;
    }

    if (this.category.categoryName != this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES')) {
      activeFilters++;
    }

    if (this.subCategory.subCategoryName != this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES')) {
      activeFilters++;
    }

    if (this.entriesSelected) {
      activeFilters += this.entriesSelected.filter(entry => entry.entryId != -1 && entry.selected).length;
    }

    return activeFilters;
  }

  filterInstitutions(res: any[]): void {
    this.filtersService.institutionsList = res.filter((inst) => ((this.roleId > 2 ? inst.institution.institution.status : true)
      && (this.roleId <= 2 ? inst.institution.shareDataWithHartmann : true))).map((group) => group.institution);
  }

  setMultiFilter(multiselect, multiSelectFilter, multiSelectValues, isManualUpdate = false) {
    const self = this;
    if (multiselect) {
      if (!this.showProAndSubPro) {
        this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
      } else {
        if (!this.showProfessionalSubcategory && !this.allInstitutionsProfessionalSubcategoryEnabled) {
          this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat');
        } else {
          this.showEntries = this.entriesList;
        }
      }
      this.showMultiselect = true;
      let entry = this.entriesList.find(entry => entry.entryId === multiSelectFilter);
      this.onEntryChange(entry);
      if(this.entriesSelected.length == 0) {
        var entriesSelectedSubscription = this.entriesSelectedSubject.asObservable().subscribe(res => {
            entriesSelectedSubscription.unsubscribe();
            loadMultifilter(entry);
        });
      }else{
        loadMultifilter(entry);
      }
      
    } else {
      this.entriesSelectedChips = [];
    }
    
    function loadMultifilter(entry){
      self.entriesSelected.forEach(e => e.selected = false);
        multiSelectValues.forEach(element => {
          let entry = self.entriesSelected.find(entry => entry.entryId === element.id) || {};
          entry.selected = true;
        });

        self.entriesSelectedChips = self.entriesSelected.filter(e => e.selected);
        self.setFilter(isManualUpdate);
        self.checkAllOrNothing();    
        self.checkViewMoreButtonVisibility();
        self.updateSelectedEntriesCount();
    }
  }

  toggleMultiselect(evt: Event) {
    evt.stopPropagation();
    if (this.roleId == 1 && (!this.country.countryID || this.country.countryID == 0)) {
      this.showProfessionalSubcategory = true;
    }
    this.checkAllInstitutionsHasProfessionalSubcategoryEnabled();
    if (!this.showProAndSubPro) {
      this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat' && entry.entryId !== 'cat');
    } else {
      if (!this.showProfessionalSubcategory && !this.allInstitutionsProfessionalSubcategoryEnabled) {
        this.showEntries = this.entriesList.filter(entry => entry.entryId !== 'subcat');
      } else {
        this.showEntries = this.entriesList;
      }
    }

    if(this.setCategory && this.setSubCategory == 0){
      this.subCategoryListLoaded = this.allSubCategoryList.filter(subCat => subCat.categoryID == this.setCategory.categoryID);
      this.subCategoryListLoaded = this.subCategoryListLoaded.sort((a, b) => {
        return (this.layoutService.translateText(a.subCategoryName)).localeCompare(this.layoutService.translateText(b.subCategoryName));
      });
    }
    this.onEntryChange(this.entriesList[0]);
    // this.showMultiselect = !this.showMultiselect;
  }

  onEntryChange(entry) {
    this.entrySelected = entry;
    this.multiselectOption = this.layoutService.translateText(entry.name);
    switch (entry.entryId) {
      case 'dept':
        if (this.filtersService.departmentList) {
          this.entriesSelected = [];
          this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentList.map((dept) => { return { entryId: dept.departmentID, name: dept.departmentName, selected: false } }));
          this.entriesSelected = this.entriesSelected.sort((a, b) => {
            return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
          });
          this.entriesSelectedSubject.next(true);
        }else{
          var subscriptionDepartmentList = this.filtersService.departmentListSubject.asObservable().subscribe(res => {
            this.entriesSelected = [];
            this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentList.map((dept) => { return { entryId: dept.departmentID, name: dept.departmentName, selected: false } }));
            this.entriesSelected = this.entriesSelected.sort((a, b) => {
              return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
            });
            this.entriesSelectedSubject.next(true);
          })
        }
        break;
      case 'deptType':
        if (this.filtersService.departmentTypeList) {
          this.entriesSelected = [];
          this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentTypeList.map((deptType) => { return { entryId: deptType.departmentTypeID, name: deptType.departmentTypeName, selected: false } }));
          this.entriesSelected = this.entriesSelected.sort((a, b) => {
            return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
          });
          this.entriesSelectedSubject.next(true);
        }else{
          var subscriptionDepartmentTypeList = this.filtersService.departmentTypeListSubject.asObservable().subscribe(res => {
            this.entriesSelected = [];
            this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentTypeList.map((deptType) => { return { entryId: deptType.departmentTypeID, name: deptType.departmentTypeName, selected: false } }));
            this.entriesSelected = this.entriesSelected.sort((a, b) => {
              return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
            });
            this.entriesSelectedSubject.next(true);
          });
        }
        break;
      case 'ward':
        this.entriesSelected = [];
        if (this.filtersService.wardList) {
          this.loadMultiFilterWards();
        }else{
          var subscriptionWardList = this.filtersService.wardListSubject.asObservable().subscribe(res => {
            this.loadMultiFilterWards();
          });
        }
        break;
      case 'cat':
        if (this.filtersService.professionalCategoryList) {
          this.entriesSelected = [];
          this.entriesSelected = this.entriesSelected.concat(this.filtersService.professionalCategoryList.map((cat) => { return { entryId: cat.categoryID, name: cat.categoryName, selected: false } }));
          this.entriesSelected = this.entriesSelected.sort((a, b) => {
            return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
          });
          this.entriesSelectedSubject.next(true);
        }else{
          var subscriptionProfessionalCategory = this.filtersService.professionalCategorySubject.asObservable().subscribe(res => {
            this.entriesSelected = [];
            this.entriesSelected = this.entriesSelected.concat(this.filtersService.professionalCategoryList.map((cat) => { return { entryId: cat.categoryID, name: cat.categoryName, selected: false } }));
            this.entriesSelected = this.entriesSelected.sort((a, b) => {
              return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
            });
            this.entriesSelectedSubject.next(true);
          });
        }
        break;
      case 'subcat':
        if (this.filtersService.subCategoryList) {
          this.loadMultiFilterSubcategories();
        }else{
          var subscriptionSubCategoryList = this.filtersService.subCategoryListSubject.asObservable().subscribe(res => {
            this.loadMultiFilterSubcategories();
          });
        }
        break;
    }
    
    this.entriesSelectedChips = [];
    this.checkAllOrNothing();    
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
  }

  loadMultiFilterWards() {
    if (this.entrySelected.entryId == 'ward') {
      this.entriesSelected = [];
      if (this.setInstitution) {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.wardList.filter(ward => ward.institutionID == this.institution.institutionID).map((ward) => { return { entryId: ward.wardID, name: ward.wardName, selected: false } }));
      } else {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.wardList.map((ward) => { return { entryId: ward.wardID, name: ward.wardName, selected: false } }));
      }

      this.entriesSelected = this.entriesSelected.sort((a, b) => {
        return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
      });
      this.entriesSelectedSubject.next(true);
    }
  }

  loadMultiFilterSubcategories() {
    if (this.entrySelected.entryId == 'subcat') {
      this.entriesSelected = [];
      if (this.category.categoryID && this.category.categoryID !== 0) {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.subCategoryList.filter(sub => sub.categoryID == this.category.categoryID).map((sub) => { return { entryId: sub.subCategoryID, name: this.layoutService.getSubCategoryName(sub), selected: false } }));
      } else {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.subCategoryList.map((sub) => { return { entryId: sub.subCategoryID, name: this.layoutService.getSubCategoryName(sub), selected: false } }));
      }

      this.entriesSelected = this.entriesSelected.sort((a, b) => {
        return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
      });
      this.entriesSelectedSubject.next(true);
    }
  }

  toggleEntry(evt: Event, entry) {
    evt.stopPropagation();
    evt.preventDefault();
    this.checkAllOrNothing();
    this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected);
    this.updateSelectedEntriesCount();
    this.checkViewMoreButtonVisibility();
  }

  updateSelectedEntriesCount(): void {
    this.selectedEntriesCount = this.entriesSelected.filter(e => e.selected).length;
  }

  getEntriesSelected() {
    let selection = this.entriesSelected.filter(e => e.selected);
    if (selection.length > 0) {
      this.entryNothingSelected = false;
      return selection;
    } else {
      this.entryNothingSelected = true;
      return [];
    }
  }

  deselectEntry(evt: Event, entry, evaluate = false) {
    evt.stopPropagation();
    entry.selected = false;
    this.checkAllOrNothing();
    if (evaluate) {
      this.setFilter();
    } else {
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected);
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
  }

  checkAllOrNothing() {
    this.entryNothingSelected = false;
    // this.entriesSelected.forEach((e, index) => {
    //   if (index > 0) {
    //     if (!e.selected) {
    //       // this.allEntriesChecked = false;
    //     }
    //   }
    // });
    this.entryNothingSelected = this.entriesSelected.every(e => !e.selected);

  }

  multiSelectRemoved() {
    this.showMultiselect = false;
    this.entriesSelected = [];
    this.entriesSelectedChips = [];
  }

  showMultiselectChip(entryId) {
    return !this.showMultiselect || (this.showMultiselect && this.entrySelected.entryId != entryId);
  }

  checkAllInstitutionsHasProfessionalSubcategoryEnabled() {
    this.allInstitutionsProfessionalSubcategoryEnabled = true;
    this.institutionsList.forEach(inst => {
      if (!inst.enableProfessionalSubCategory) {
        this.allInstitutionsProfessionalSubcategoryEnabled = false;
      }
    })
  }

  async checkViewMoreButtonVisibility() {
    setTimeout(() => {
      this.lessMoreIsVisible = false;
      if (this.chipsDiv.nativeElement.offsetHeight > 70) {
        this.lessMoreIsVisible = true;
        this.viewMore = false; // reset view more
      }
    }, 50);
  }

  onResize(event) {
    this.checkViewMoreButtonVisibility();
  }
}
